!function() {
  "use strict";

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest("product-info");
      this.form = this.section?.querySelector("[data-product-form]");
      this.formWrapper = theme.settings.productPageSticky && this.section?.querySelector("[data-form-wrapper]") || this.form;

      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
      document.addEventListener("theme:resize", this.boundSetCartBarHeight);
      document.addEventListener("theme:product:add-error", this.handleProductAddError);
    }

    handleClick(evt) {
      const addButton = evt.target.closest("[data-cart-bar-add-to-cart]");
      const scrollButton = evt.target.closest("[data-cart-bar-scroll]");

      // ✅ Use default form submission instead of dispatching fake clicks
      if (addButton) {
        evt.preventDefault();
        addButton.classList.add("is-loading");
        addButton.setAttribute("disabled", "disabled");

        if (this.form) {
          // Trigger native Shopify form submission
          this.form.dispatchEvent(new Event("submit", { bubbles: true }));
        } else {
          console.warn("No product form found for Cart Bar.");
        }

        setTimeout(() => {
          addButton.classList.remove("is-loading");
          addButton.removeAttribute("disabled");
        }, 2000);

        return;
      }

      if (scrollButton) {
        evt.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      this.querySelector("[data-cart-bar-add-to-cart]") && this.scrollToTop();
    }

    scrollToTop() {
      const variantSelect = this.section?.querySelector("variant-selects");
      const rectTop = (window.theme.isMobile() ? variantSelect || this.form : this.section).getBoundingClientRect().top;
      window.theme.scrollTo(window.theme.isMobile() ? rectTop - 10 : rectTop);
    }

    toggleCartBarOnScroll() {
      const scrollY = window.scrollY;
      if (this.formWrapper) {
        const show = scrollY > this.formWrapper.offsetTop + this.formWrapper.offsetHeight;
        this.classList.toggle("is-visible", show);
      }
    }

    setCartBarHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty("--cart-bar-height", `${height}px`);
    }

    disconnectedCallback() {
      document.removeEventListener("theme:product:add-error", this.handleProductAddError);
      document.removeEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
      document.removeEventListener("theme:resize", this.boundSetCartBarHeight);
    }
  }

  customElements.get("cart-bar") || customElements.define("cart-bar", CartBar);
}();

